import Form from '@/components/Form'
import items from '../forms/font'
import React, { useEffect } from 'react'
import { Button } from '@/components/UiElements'
import mapToLoad from '@/components/FontManager/mapData/mapToLoad'
import Splash from '@/components/splash/Splash'

type FontFormProps = {
	updateFont: any
	saveFont: (data:any)=>void
}

export default function FontForm({updateFont, saveFont}:FontFormProps) {

	const formRef = React.useRef<any>(null)
	const [isLoading, setIsLoading] = React.useState<boolean>(false)


	const handleAddRule = async () => {
		setIsLoading(true)
		const validation = false
		if (!validation) {
			const data = await formRef.current?.getData() || {}
			await saveFont(data);
			setIsLoading(false)
		}
	}


	const loadFont = async () => {
		if (updateFont) {
			setIsLoading(true)
			const mappedFont = await mapToLoad(updateFont)


			formRef.current?.setData(mappedFont)
			setIsLoading(false)
		} else {
			formRef.current?.setData({})
		}

	}

	useEffect(() => {
		loadFont()
	}, [updateFont])


	return (
		<div className={"flex flex-col gap-xxxl"}>
			{isLoading && <Splash /> }
			<div className={'w-[850px] grid grid-cols-12 gap-md'}>
				<Form ref={formRef} items={items} />

			</div>
			<Button
				size="lg"
				onClick={handleAddRule}
			>
				{updateFont ? "Update Font Item" : "Add New Font" }
			</Button>
		</div>
	)
}